import algoliasearch from 'algoliasearch'

export const initIndex = (appId, apiKey, indexName) => algoliasearch(appId, apiKey).initIndex(indexName)
